import { useTranslation } from 'react-i18next';

import { NAMESPACE_TRANSLATION } from 'internationalise';
import {
  defaultDateFormat,
  shortMonthFormat,
} from 'approot/shared/logic/dates';

export function DateText({
  date,
  isShortMonth,
}: {
  date?: Date | string | null;
  isShortMonth?: boolean;
}) {
  const { t } = useTranslation(NAMESPACE_TRANSLATION);

  if (!date) {
    return null;
  }

  const d = typeof date === 'string' ? new Date(date) : date;
  return <>{isShortMonth ? shortMonthFormat(d, t) : defaultDateFormat(d, t)}</>;
}
